import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class TrimDescriptionReferenceService extends BaseReferenceService {
  constructor() {
    super('TrimDescriptionReference');
  }
}
